















import { Component, Prop, Vue } from "vue-property-decorator";
import IconBase from "@/common/components/atoms/IconBase.vue";

import IconInvestedRoundedType1 from "@/common/components/icons/IconInvestedRoundedType1.vue";
import IconInvestedRoundedType2 from "@/common/components/icons/IconInvestedRoundedType2.vue";
import IconInvestedRoundedType3 from "@/common/components/icons/IconInvestedRoundedType3.vue";
import IconInvestedRoundedType4 from "@/common/components/icons/IconInvestedRoundedType4.vue";
import IconInvestedRoundedType5 from "@/common/components/icons/IconInvestedRoundedType5.vue";
import IconInvestedRoundedType6 from "@/common/components/icons/IconInvestedRoundedType6.vue";
import IconInvestedRoundedType7 from "@/common/components/icons/IconInvestedRoundedType7.vue";
import IconInvestedRoundedType8 from "@/common/components/icons/IconInvestedRoundedType8.vue";
import IconInvestedRoundedType9 from "@/common/components/icons/IconInvestedRoundedType9.vue";
import IconInvestedRoundedType10 from "@/common/components/icons/IconInvestedRoundedType10.vue";
import IconInvestedRoundedType11 from "@/common/components/icons/IconInvestedRoundedType11.vue";
import IconInvestedRoundedType12 from "@/common/components/icons/IconInvestedRoundedType12.vue";

@Component({
  components: {
    IconBase,
    IconInvestedRoundedType1,
    IconInvestedRoundedType2,
    IconInvestedRoundedType3,
    IconInvestedRoundedType4,
    IconInvestedRoundedType5,
    IconInvestedRoundedType6,
    IconInvestedRoundedType7,
    IconInvestedRoundedType8,
    IconInvestedRoundedType9,
    IconInvestedRoundedType10,
    IconInvestedRoundedType11,
    IconInvestedRoundedType12
  }
})
export default class IconInvestedRounded extends Vue {
  @Prop({ type: Number, default: 135 }) iconSize!: number;
  @Prop({ type: Number || String, default: 1 }) type!: number | string;
  @Prop({ type: String, default: "#ffffff" }) iconColor!: string;
  @Prop({ type: String, default: "#ee1c25" }) bgColor!: string;

  get iconComponent() {
    const { type } = this;
    return `IconInvestedRoundedType${type}`;
  }
}
